import { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query';

// import { fetch_all, fetch_one } from '../../lib/server_helper';
import { fetchAllWithCount } from '../../lib/v31lib';
import { loginAtom } from '../../lib/auth';
// import { checkAllowed } from '../../lib/permission';

// import {
//   Grid
// } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import {
  DataGrid,
  Page,
  StyledIconButton,
} from '../../components/interface';

import { Export } from '../../models/Export';

import { getCookie, setCookie } from 'react-use-cookie';

const { DateTime } = require("luxon");

type Props = {};

export const AdminExports: FunctionComponent<Props> = () => {
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [login, setLogin] = useAtom(loginAtom);

  const params = useParams();
  const projectId: string | undefined = params.id;

  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("id DESC");
  const [activeCompany, setActiveCompany] = useState<string>(getCookie('cribeon_active_company_id') || '');
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);
  let count = 0;

  // Settings
  
  const {
    data: objects,
    isLoading: objectsLoading,
    // isError: bookYearsError,
    // isSuccess: bookYearsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["exports", activeCompany, {page: page, order: order}],
    queryFn: () =>
      fetchAllWithCount<Export>(
        "/nl/v3/objects/fetch_all",
        {
          object: 'export',
          fields: ['id', 'created_at', 'get_item', 'name', 'user', 'project'],
          sub_fields: {
            project: ['id', 'name']
          },
          per_page: 20,
          page: page,
          order: order,
          filter: {
            search: '',
            advanced: {
              company_id: activeCompany,
              fallback: ''
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!login && !!activeCompany
  });





  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 100, sortable: true },
    { field: 'name', headerName: 'Name', width: 200, sortable: true },
    { field: 'user_full_name', headerName: 'User', width: 200, sortable: true },
    { field: 'project_name', headerName: 'Project', width: 200, sortable: true },
    { field: 'created_at', headerName: 'Created', width: 120, valueFormatter: params => DateTime.fromISO(params?.value).toFormat("D") },
  ];

  return (
    <Page sx={{}} title={t("objects.exports.title")}>
      <DataGrid
        action_count={1}
        actions={(params) => {
          return (<>
            {!!params.row.get_item && <StyledIconButton title="Download" color="primary" onClick={() => {
              window.open(params.row.get_item, "_BLANK");
            }}>
              <CloudDownloadIcon />
            </StyledIconButton>}
          </>);
        }}
        getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
        objectCount={count}
        objects={(objects || []).map(u => ({
          ...u,
          user_full_name: [u.user?.first_name, u.user?.last_name].join(" "),
          project_name: u.project.name || '',
        }))}
        columns={columns}
        loader={objectsLoading}
        onSortModelChange={(a, b) => {
          let a_0_field:string = a[0].field;
          setOrder([a_0_field, a[0].sort].join(' '));
        }}
        page={page}
        setPage={(p) => {setPage(p);}}
      />

      {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
    </Page>
  );
}
